// Le clavier d'un tiroir modal (`aria-modal="true"`) — extrait du panneau « Comprendre ce chiffre »
// (`Explication.tsx`) pour servir aussi au tiroir des étapes Sitadel (lot C, revue codex P2 de la
// PR #690 : Tab sortait du tiroir, et une fois le focus sorti Échap ne fermait plus).
//
// Échap ferme, écouté sur la FENÊTRE : il ferme même quand le focus est sur le voile ou ailleurs.
// Le focus est PIÉGÉ : un lecteur au clavier qui tabule hors du panneau se retrouverait à parcourir
// la page qu'il ne voit plus (le voile la recouvre) — le défaut classique des tiroirs modaux (WCAG
// 2.4.3 / 2.1.2). Tab sur le dernier élément revient au premier, Maj+Tab sur le premier va au
// dernier, et un focus égaré hors du panneau y rentre au premier Tab.
import { useEffect, useRef, type RefObject } from 'react'

export const FOCALISABLES = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), '
  + 'textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])'

export function usePiegeFocus(panneau: RefObject<HTMLElement | null>, onClose: () => void, actif = true) {
  // Le rappel change à chaque rendu chez l'appelant : on le lit dans une référence, l'écoute reste posée.
  const onCloseRef = useRef(onClose)
  useEffect(() => { onCloseRef.current = onClose })
  useEffect(() => {
    if (!actif) return
    const h = (e: KeyboardEvent) => {
      if (e.key === 'Escape') { e.stopPropagation(); onCloseRef.current(); return }
      if (e.key !== 'Tab' || !panneau.current) return
      const cibles = panneau.current.querySelectorAll<HTMLElement>(FOCALISABLES)
      if (!cibles.length) return
      const premier = cibles[0]
      const dernier = cibles[cibles.length - 1]
      const dedans = panneau.current.contains(document.activeElement)
      if (e.shiftKey && (document.activeElement === premier || !dedans)) {
        e.preventDefault(); dernier.focus()
      } else if (!e.shiftKey && (document.activeElement === dernier || !dedans)) {
        e.preventDefault(); premier.focus()
      }
    }
    window.addEventListener('keydown', h)
    return () => window.removeEventListener('keydown', h)
  }, [actif, panneau])
}
